import IconsTextNavigation from 'components/global/IconsTextNavigation'
import DonationModal from 'pages/Events/Views/Common/Modals/DonationModal'
import React, { useState } from 'react'
import { leagueEventStore } from 'state/league/leagueEvent'

const Donation: React.FC = () => {
  const { leagueData } = leagueEventStore(store => ({
    leagueData: store.leagueData,
  }))
  const [donationModal, setDonationModal] = useState<boolean>(false)

  return (
    <>
      <div onClick={() => setDonationModal(true)}>
        <IconsTextNavigation
          iconName="HandHeart"
          heading="Donations"
          isCompleted={leagueData?.allowDonation}
        />
      </div>

      {donationModal && (
        <DonationModal
          openModal={donationModal}
          setOpenModal={setDonationModal}
          reference="league"
        />
      )}
    </>
  )
}

export default Donation
